import { createAsyncThunk } from "@reduxjs/toolkit";

import { addDockrestrictionReport, getDockrestrictionReport } from "../../apis/dockRestriction";

export const addDockrestrictionReportData = createAsyncThunk("dockRestriction/addDockRestriction", async({
    data,
  }: {
    data: {
      [key: string]: any;
    };
  },{ rejectWithValue })=>{
    try {
        // Call the correct API function with optional parameters
        const response = await addDockrestrictionReport(data);
        return response
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const getDockrestrictionReportData = createAsyncThunk(
  "getDockRestriction/getDockRestrictionReport",
  async (
    { notification_intro, mode, portCalls}: { notification_intro: string; mode: string; portCalls: string; },
    { rejectWithValue }
  ) => {
    try {
      // Pass the parameters to the API function
      const response = await getDockrestrictionReport({
        mode,
        portCalls,
        notification_intro,
      });
      return response.data;
    } catch (error: any) {
      console.error("Error fetching port call notification:", error);
      return rejectWithValue(error.message || "Failed to fetch port call notification");
    }
  }
);